import { Component, OnInit, Input } from '@angular/core';
import { PayService } from '../../invoices/pay.service';
import { PopoverController } from '@ionic/angular';
import { DialogService } from '../../_services';
import { TranslateService } from '@ngx-translate/core';
import { CreditNotesService } from '../../creditnotes/creditnotes.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CurrencyDisplayService } from '../../_services/currency-display.service';

@Component({
  selector: 'credit-notes-selection',
  templateUrl: './credit-notes-selection.component.html',
})
export class CreditNotesSelectionComponent implements OnInit {
  @Input() payData: any = {};
  payModel;
  ios = false;
  creditNotesSelectConfig : any = {};
  hideDivisionForCreditNotes = false;
  hideCreditNoteTagOnPayScreen = false;
  allCreditNotesSelected = false;
  multiCreditNotesSelectionMode = 'Lowest Amt first';
  creditNotesSortDir = 'asc';
  creditNoteSelectionTimeout;
  formattedBankAmount: string;

  constructor(
    private payService: PayService,
    private modalCtrl: NgbActiveModal,
    private dialogService: DialogService,
    private creditNoteService: CreditNotesService,
    private translate: TranslateService,    
    private currencyDisplayService: CurrencyDisplayService
  ) { }

  ngOnInit() {
    this.hideDivisionForCreditNotes = this.payData.invoiceData.hideDivisionForCreditNotes;
    this.hideCreditNoteTagOnPayScreen = this.payData.invoiceData.hideCreditNoteTagOnPayScreen;
    this.payModel = this.payData.payModel;
    this.payData.checkCreditNotesToBeDisabled();
    this.creditNotesSelectConfig = this.payData.creditNotesSelectConfig || this.creditNoteService.getInitConfig();
    
    if(this.creditNotesSelectConfig.sortDir == 'desc'){
      this.payData.creditNotes.sort((a,b) => {
        // if(a.amount < b.amount){
        //       return -1
        // }else
        if(a.amount > b.amount){
          return -1
        }else
          return 1
      });
    }

    this.getFormattedBankAmount()
    
  }

  getFormattedBankAmount(){
    let bankAmount = {
      amt: 0,
      curr: ''
    };
    bankAmount.amt = this.payData.bankAmt;
    bankAmount.curr = this.payData.invoice.currCode; 

    
    this.formattedBankAmount = this.currencyDisplayService.getFormattedCurrencyStr(bankAmount);

  }

  close() {
    this.modalCtrl.dismiss();
  }

  creditNoteSelected() {
    this.payData.getPayableAmount();
    this.payData.checkCreditNotesToBeDisabled();
  }

  getButtonText() {
    return (this.payData && this.payData.creditNotesSelected) ? `${this.translate.instant('LABELS.SELECT')}` : this.translate.instant('LABELS.CLOSE');
  }

  clearCreditNotesSelection() {
    this.payData.clearCreditNotesSelection();
    this.payData.getPayableAmount();
    this.payData.checkCreditNotesToBeDisabled();
  }

  dismiss(data?: any) {
    const btnText = this.getButtonText();
    if (btnText === this.translate.instant('LABELS.CLOSE')) {
      this.modalCtrl.dismiss(data);
      this.checkForCD();
    } else {
      const msg = this.payData.validateSelectedCRN();
      if (msg) {
        this.dialogService.showInfoAlert(msg);
      } else {
        this.modalCtrl.dismiss(data);
        this.checkForCD();
      }
    }
  }

  private checkForCD() {
    this.payData.getCashDiscount(this.payData);
  }

  creditNotesSelectionToggled() {
    this.clearCreditNotesSelection();
    if (this.allCreditNotesSelected) {
      //this.payData.autoSelectCreditNotes(this.multiCreditNotesSelectionMode);
      this.startAutoSelectionOfCreditNotes(0);
    }
  }

  private startAutoSelectionOfCreditNotes(creditNoteIndex) {
    if (this.creditNoteSelectionTimeout) {
      clearTimeout(this.creditNoteSelectionTimeout);
    }
    if (this.payData.retrievingCashDiscount) {
      this.creditNoteSelectionTimeout = setTimeout(() => {
        this.startAutoSelectionOfCreditNotes(creditNoteIndex);
      }, 200);
      return;
    }
    const creditNote = this.payData.creditNotes[creditNoteIndex];
    if (creditNote && !creditNote.disabled) {
      creditNote.selected = true;
      this.creditNoteSelected();
    }
    //setTimeout(() => {
    const existsEnabledCreditNote = this.payData.creditNotes.findIndex(item => !item.disabled && !item.selected);
    if (existsEnabledCreditNote !== -1) {
      this.startAutoSelectionOfCreditNotes(existsEnabledCreditNote);
    }

  }

  sortCreditNotes() {
    this.allCreditNotesSelected = false;
    this.creditNoteService.sortCreditNotes(this.creditNotesSelectConfig, this.payData.creditNotes, this.payData.bankAmt);
    this.payData.creditNotesSelectConfig = this.creditNotesSelectConfig;
  }

  creditNotesSortToggled() {

  }

}
